import { Link, Outlet } from 'react-router-dom'
import { Home } from 'lucide-react'
import { AuthModal } from '@/components/auth/AuthModal'
import { SITE } from '@/lib/site'
import { PATHS } from '@/routes/paths'
import { RouteSeoFallback } from '@/components/RouteSeoFallback'

/**
 * Minimal chrome for mobile-app WebView pages (calculator, realestate-book,
 * premium_benifits). Matches the old Blade standalone pages that only showed
 * the QBC logo. AuthModal is required so Buy Now / package checkout can open
 * login inside the app WebView (this layout is outside AppLayout).
 */
export function ToolPageLayout() {
  return (
    <div className="min-h-screen bg-white">
      <RouteSeoFallback />
      <header className="bg-white pt-6">
        <div className="relative mx-auto flex max-w-6xl items-center justify-center px-4">
          <Link
            to={PATHS.home}
            className="absolute left-4 top-1/2 inline-flex -translate-y-1/2 items-center gap-1.5 rounded-full border border-neutral-200 bg-white px-3 py-1.5 text-xs font-semibold text-qbc-navy shadow-sm transition-colors hover:border-primary-200 hover:bg-primary-50 hover:text-primary-700 sm:left-4 sm:px-3.5 sm:text-sm"
          >
            <Home className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
            Home
          </Link>
          <Link to={PATHS.home} className="inline-flex items-center justify-center" aria-label={`${SITE.name} home`}>
            <img
              src={SITE.logoSmall}
              alt={SITE.name}
              className="h-16 w-auto max-w-[70%] object-contain sm:h-20 sm:max-w-[85%]"
            />
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-3 pb-10 pt-6 sm:px-4">
        <Outlet />
      </main>
      <AuthModal />
    </div>
  )
}
